import { render, staticRenderFns } from "./MigrateDialog.vue?vue&type=template&id=88cac014"
import script from "./MigrateDialog.vue?vue&type=script&lang=js"
export * from "./MigrateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports